import React from 'react';
import { Spin } from 'antd';
import Scrollbars from 'react-custom-scrollbars';
import project from '../../../images/project.png';
import UploadWall from '../../../../upload/UploadWall';
import { connect } from 'react-redux';
//import UploadItem from '../../../../resource-wrap/common-wrap/pictureItem/upLoadItem'

const BasicInfo = (props) => {

console.log( props.projectAttachment)
    return(
        <>
         <Scrollbars >
             <div className="basicinfo-content">
            {/* <div className="top">
                <img src={project} alt="" />
                <span>新闻报道</span>
            </div> */}
            <div className="middle">
                <div className="line_1">
                    <div className="left">
                      <span>项目名称: </span>
        <span>{props.projectName}</span>
                    </div>
                    <div className="right">
                        <span>项目负责人: </span>
        <span>{props.projectCreater}</span>
                    </div>
                </div>
                <div className="line_2">
                    <span>项目内容: </span>
        <span>{props.projectContent}</span>
                </div>
                <div className="line_3">
                    <div className="label">项目附件:</div>
                    <div className="items">
                   
                    {/* <UploadItem  fileList={props.projectAttachment} showIcon={['download']} fileType="附件"  /> */}
                        {/* {
                            props.projectAttachment.length > 0 && props.projectAttachment.map((item) => (
                                <div>
                              
                            <span>{item.name}</span>
                            </div>

                            ))
                        } */}
                    {/* <div>
                        <img src={project} alt="" />
                        <span>文档.doc</span>
                    </div>
                    <div>
                        <img src={project} alt="" />
                        <span>文档.rar</span>
                    </div> */}
                    </div>
                    
                </div>
            </div>
            
            {
                props.projectAttachment  && props.projectAttachment.length > 0 && 
                <UploadWall
                   
                   multiple={true}
                   action="/cm-sites-pms/index/uploadFile"
                   listType="picture-card"
                   fileList={props.projectAttachment}
                   icons={["download"]}
                   showUploadBtn={false}
                   listType={"list"}
                   onDownload={(file)=>{
                       if(file.path.indexOf("?") === -1){
                           window.location.href = file.path + "?download=1";
                       }else{
                           window.location.href = file.path + "&download=1";
                       }
                   }}
               />
            }
        </div>
        </Scrollbars>
        {/* <Spin className="loading"/> */}
        </>
    )
}

const mapStateToProps = (state) => {
    return{
        projectName: state.projectReducer.projectName,
        projectCreater: state.projectReducer.projectCreater,
        projectContent: state.projectReducer.projectContent,
        projectAttachment: state.projectReducer.projectAttachment,
        platform: state.projectReducer.platform
    }
}

export default connect(mapStateToProps)(BasicInfo)